/** Subtotal from invoice line rows (staff API shape). */
export function calcLineSubtotal(lines = []) {
  return lines.reduce(
    (sum, line) =>
      sum +
      (parseFloat(line.quantity) || 0) *
        (parseFloat(line.unit_price ?? line.unitPrice) || 0),
    0
  );
}

export function calcInvoiceDiscountAmount(invoice, subtotal) {
  const dv = parseFloat(invoice?.discount_value) || 0;
  if (invoice?.discount_type === "percent") return subtotal * (dv / 100);
  return dv;
}

/** Financial breakdown for a single invoice record from the API. */
export function calcInvoiceFinancials(invoice) {
  const lines = invoice?.InvoiceLines || [];
  const subtotal = calcLineSubtotal(lines);
  const discountAmt = calcInvoiceDiscountAmount(invoice, subtotal);
  const totalFromDb = parseFloat(invoice?.total_amount);
  const total = Number.isFinite(totalFromDb)
    ? totalFromDb
    : Math.max(0, subtotal - discountAmt);
  return {
    subtotal,
    discountAmt,
    total,
    discountType: invoice?.discount_type || "fixed",
    discountValue: parseFloat(invoice?.discount_value) || 0,
  };
}

/** Sum financials across all invoices linked to an order. */
export function calcInvoicesFinancials(invoices = []) {
  if (!invoices.length) return null;
  return invoices.reduce(
    (acc, inv) => {
      const f = calcInvoiceFinancials(inv);
      return {
        subtotal: acc.subtotal + f.subtotal,
        discountAmt: acc.discountAmt + f.discountAmt,
        total: acc.total + f.total,
      };
    },
    { subtotal: 0, discountAmt: 0, total: 0 }
  );
}
